var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGabbieMeh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D3A798;}\r\n\t.st1{fill:#D27B72;}\r\n\t.st2{fill:#AA867D;}\r\n\t.st3{fill:#E5BDB3;}\r\n\t.st4{fill:#4E0904;}\r\n\t.st5{opacity:0.98;fill:#4E0904;}\r\n\t.st6{fill:#BA2597;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#453633;}\r\n\t.st9{fill:#DD6688;}\r\n\t.st10{fill:#F5F4F3;}\r\n\t.st11{fill:#030303;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sleepy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "face_00000127029295964278561560000017891397553357294772_",
    className: "st0",
    d: "M903.2,519.2 c0,224.5-181.1,406.4-404.4,406.4S87.4,747.8,87.4,523.4s188-410.6,411.4-410.6c124.8,0,225.8,67.4,300,156.6 C857.4,340,903.2,420.1,903.2,519.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cheeks_00000013891747764976519000000014550047465710602169_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 733.1,
    cy: 592,
    rx: 85.9,
    ry: 87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 268.6,
    cy: 595,
    rx: 85.9,
    ry: 83.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "nose_00000129180145196406094590000011376405782538696377_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nose-bridge_00000021823201176014905480000015093741345632145554_",
    className: "st0",
    d: "M524.2,542.4 c-15.6-5.8-31.3-9.1-47.5-2.6c-7.6,3.1-13-5.7-20.3-3.2c2.2-8.4,4.4-16.9,6.4-25.4c1.2-4.9,4.4-6.8,9-6.8c3.8,0,7.5,0.1,11.3,0.1 C518.3,504.6,520.1,506.2,524.2,542.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose-shadow_00000121281254806762450190000003492957913816852396_",
    className: "st2",
    d: "M421,576.1 c9.9-8.7,18.3-17.8,26.4-27.9c3.6-4.5,9.7-6.1,15-3.9c3.8,1.6,7.7,3.3,12.2,1.7c16.9-6,33.5-3.6,49.8,1.4 c2.3,0.7,4.3,2.1,5.8,3.9c9.5,11.1,22.5,15.5,34.4,23.3c7.1,4.6,7.9,14.8,1.6,20.4c-6.8,6-15,10.8-20.3,10.1 c-7.7-1-12.5,1.2-17.9,4.4c-20.7,12.4-41.3,12.5-61.7-0.2c-5.5-3.4-10.8-4.4-18-4.1c-7.9,0.2-17-3.6-25.3-8.4 C415.5,592.4,414.5,581.9,421,576.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "nose_00000057110319379892801670000007200854115557042872_",
    className: "st3",
    d: "M431,567.7c7.1-7.2,13.5-14.7,19.6-22.8 c4.2-5.7,11.8-8,18.4-5.4c2.4,1,5,1.5,7.8,0.3c14.4-5.8,28.5-3.8,42.4,0.8c3,1,5.6,2.8,7.6,5.3c7.5,9.4,17.5,13.9,27,20.2 c9,5.9,9.8,18.7,1.5,25.6c-5.4,4.6-11.3,7.8-15.2,7.2c-6.8-1-11.1,1.2-15.8,4.4c-18.3,12.4-36.6,12.5-54.8-0.2 c-4.9-3.4-9.6-4.4-15.9-4.1c-6.1,0.2-12.9-2.5-19.4-6.3C425.2,587.5,423.7,575.1,431,567.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "brows_00000100367677556937010780000002693520599940666253_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "brow_00000164489338373892877540000007264650550820780433_",
    className: "st4",
    d: "M313,361.7c20.2-19,42.8-17.5,65.4-10.7 c18,5.4,34.8,14.1,50.5,24.6c10.9,7.3,11.2,9,2.5,21C397.9,365.4,362.8,338.8,313,361.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "brow_00000132066005577465081870000004700638489440591279_",
    className: "st5",
    d: "M682.3,361.7C660,342.7,635,344.2,610,351 c-19.9,5.4-38.5,14.1-55.8,24.6c-12.1,7.3-12.4,9-2.8,21C588.5,365.4,627.3,338.8,682.3,361.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hair_00000000195900684177825180000007535116135587462579_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1079.8,742.4c-6.3,41.6-20.3,79.7-49.7,110.8c-23,24.3-51.4,37.2-84.6,42c-41.2,6-80.2-2.4-118.9-14.9 c-7.4-2.4-14.9-2.7-22.1-0.2c-32,11.2-59.8,3.9-84.3-18.5c0.3-5.5,4.7-7.4,8.5-10.1c69.7-48.8,119.8-112.9,149.3-192.7 c21-56.6,28.9-115.1,23.7-175.4c-0.5-5.7-1.5-9.5-8-10.6c-42.1-7.2-60.2-39.2-74.9-74c-7.5-17.7-13.3-36.2-20-54.3 c-8.9-24-23-28.3-43.3-13.3c-27.1,20-58.3,19.3-84.6-1.9c-5.2-4.2-10.4-8.5-15-13.3c-10.4-10.9-19.1-22.6-21.4-38.6 c-2.3-16.4-9.4-31-20.7-43.7c-16-17.9-36.2-25.2-59.4-25.2c-36.8,0-71.6-6.8-103-27.1c-5.8-3.7-8.3-7.9-9.3-15 c-2.2-16.3-0.9-32.7-2.2-49c6.1-4.2,13.4-3.8,20.1-4.2c36.1-2,72.3,0,107.9,6.2c37.2,6.4,72.8,18.6,106.9,35.2 c54.3,26.3,99.3,63.9,137.4,110.6c27.3,33.4,48.2,70.1,64.4,110.1c9.3,23,25,43,35.4,65.8c11.9,26.1,21.6,52.9,30.4,80.1 c14,43.1,26.8,86.5,40.6,129.7c4.2,13.1,12.3,24.1,20.1,35.4c17.1,24.7,42.5,36.8,69.8,45.7 C1078.6,734.2,1080.8,735.6,1079.8,742.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M430.2,147.5c4.5,41.4-18.1,69.3-46.9,93.4c-45.9,38.4-101.6,51.6-159.3,58.7c-5,0.6-9.9,1.4-14.9,1.9 c-22.2,2.6-21.9,2.6-26.4,23.8c-11.1,52.6-28.8,102.4-62.5,145.3c-2.6,3.3-5,7.1-8.3,9.4c-17.2,12-20.2,28.7-19.4,48.4 c3.3,78.9,26.3,151.1,70.2,216.8c43.3,64.9,101.3,112,171.7,144.6c-30.5,27-66.4,31.1-105.1,25.8c-39.3-5.3-73.8-21.8-106.7-42.5 c-11.6-7.3-24.4-8.2-36.9-11c-16.9-3.8-32.9-9.8-48-18.1C6.2,826.4-5.5,796.6,2.4,761.9C6.9,742.1,17.2,725,28,708.2 c3.5-5.5,7.5-6.4,13.6-3.5c19.8,9.3,31.8,3.6,37.5-17.1c5.4-19.5,2.9-39,0.1-58.5c-6.5-47.1-6.9-93.9-0.5-141.2 c7.1-52.4,24.9-100.9,50.6-146.5c14-24.7,33-46.6,47.4-71.2c16.8-28.6,38.1-53.4,63.5-73.5c27.8-22,58.6-40.6,92.3-53.4 c26.1-9.9,53.1-16.9,80-23.8c5.5-1.4,11.6-0.7,17.5-1C430,128.2,429.1,137.9,430.2,147.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eyes_00000043434622440506121720000003604395766930804635_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-shadow_00000145763751436064622230000004479050976728572832_",
    className: "st2",
    d: "M562.1,464.8c0.6-1.8,4.1-3.2,5.5-1.8 c4.1,3.9,8.9,7.7,16.4,9.2c12.4,2.5,24.7,1.8,25,2.5c0.3,0.7-13.3,6.6-28.2,4.9c-9.5-1.1-16-6.6-19-9.5c-0.7-0.7-0.9-1.6-0.6-2.5 L562.1,464.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-shadow_00000166663782210564199440000010079856380948599207_",
    className: "st2",
    d: "M555,454.6c1.1,3.8,8.1,6.6,10.9,3.8 c8.1-8.1,17.8-16,32.9-19c24.8-5.1,49.4-3.7,50.1-5.1c0.7-1.5-26.5-13.8-56.4-10.2c-19,2.3-32,13.6-37.9,19.7 c-1.3,1.4-1.8,3.3-1.2,5.1L555,454.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye",
    className: "st7",
    d: "M559.4,456c-1-8.1,16.7-18.3,32-21.3c23.7-4.7,51.1,5.9,51.3,15.3c0.2,8.7-22,23.9-39.7,25.3 C584.5,476.9,560.5,464.9,559.4,456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pupil",
    className: "st8",
    d: "M580.2,445.1c-1.5,8.8,6.9,21.6,18.6,21.3c11.3-0.4,20.2-12,18.4-20.7 c-1.6-8.2-11.4-16.4-19-16.2C591,429.7,581.5,437.1,580.2,445.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lid",
    className: "st0",
    d: "M561.1,450.5c1,1.9,18.4-11.9,41.1-12.1c15.2-0.1,29.2,2.2,38.1,6.6c-2.2-3-7.3-4.9-13.1-8.6 c-12.7-8.2-25.9-7.1-30-6.7C577.1,431.8,560.1,448.6,561.1,450.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-shadow_00000026161190653088864560000014322943290026997927_",
    className: "st2",
    d: "M405.9,466.8c-0.6-1.8-4-3.2-5.4-1.8 c-4,3.9-8.7,7.7-16.2,9.2c-12.2,2.5-24.3,1.8-24.6,2.5c-0.3,0.7,13,6.6,27.7,4.9c9.4-1.1,15.8-6.6,18.6-9.5 c0.6-0.7,0.9-1.6,0.6-2.5L405.9,466.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye-shadow_00000160191583924728651920000011367623059909986737_",
    className: "st2",
    d: "M412.8,456.6c-1.1,3.8-8,6.6-10.8,3.8 c-8-8.1-17.5-16-32.3-19c-24.4-5.1-48.6-3.7-49.2-5.1c-0.7-1.5,26.1-13.8,55.5-10.2c18.7,2.3,31.5,13.6,37.3,19.7 c1.3,1.4,1.7,3.3,1.2,5.1L412.8,456.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eye_00000178191683941382528810000001926130383379559602_",
    className: "st7",
    d: "M408.5,458c1-8.1-16.4-18.3-31.5-21.3 c-23.3-4.7-50.2,5.9-50.5,15.3c-0.2,8.7,21.6,23.9,39,25.3C383.8,478.8,407.4,466.9,408.5,458z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pupil_00000102516005051993822950000007514861055236862599_",
    className: "st8",
    d: "M388.1,447.1c1.5,8.8-6.8,21.6-18.2,21.3 c-11.2-0.4-19.8-12-18.1-20.7c1.6-8.2,11.2-16.4,18.7-16.2C377.5,431.7,386.7,439.1,388.1,447.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "lid_00000018920245095330626600000000923036117677760657_",
    className: "st0",
    d: "M406.8,452.5c-0.9,1.9-18.1-11.9-40.4-12.1 c-14.9-0.1-28.7,2.2-37.4,6.6c2.1-3,7.2-4.9,12.9-8.6c12.5-8.2,25.5-7.1,29.5-6.7C391.1,433.7,407.8,450.6,406.8,452.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lips_00000135665789511615593340000013332211688422004375_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 555.5,
    cy: 689.8,
    r: 12.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 434.9,
    cy: 691.6,
    r: 12.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M438.1,687.6c11.2-17.5,25.3-37.7,39.1-37.2c6.8,0.3,10.6,8.6,18.8,8.1c9.1-0.5,10.4-7.2,17.6-8 c17.6-2,39.4,36.3,39.4,36.4l-1.3,1.7c6.3-7.6-9.5,13.8-18.2,19.3c-21,13.4-55.2,7.3-58.5,6c-8.8-3.5-29.3-15.7-36.8-23.2 C437.2,689.8,437.5,688.5,438.1,687.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M451.6,684.2c-1.6,0.3,8.7-6.3,20.9-7c0.3,0,0.5,0,0.5,0c10.9-0.4,13.3,4.1,20.5,4.1c6.6,0,17.6-4,19.6-4.1 c0.3,0,0.6,0,0.6,0s1.2,0,2.4,0c7.7,0.3,16.6,4.7,16.6,4.7c3.4,1.7,11.5,6.3,10.1,6c-3.4-0.6-9.1-6.2-24.3-6.6 c-10.4-0.3-15.9,3.7-25.8,2.9c-9.7-0.7-10.3-2.4-18.4-2.7C460.7,681,458.4,682.9,451.6,684.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "happy"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "mood"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabbieMeh);
export default __webpack_public_path__ + "static/media/gabbie_meh.46bfd79afb354e2c5d027150525b289a.svg";
export { ForwardRef as ReactComponent };